import { render, staticRenderFns } from "./abrirlote.vue?vue&type=template&id=a37246c0&"
import script from "./abrirlote.vue?vue&type=script&lang=js&"
export * from "./abrirlote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports